import React, { useState } from 'react';
import './APartite.css';
import MatchEditor from '../../components/match/MatchEditor';

const APartite = () => {
  const [isSaving, setIsSaving] = useState(false);

  return <MatchEditor isSaving={isSaving} setIsSaving={setIsSaving} />;
};

export default APartite;